export default __webpack_public_path__ + "static/media/img (2).feec1e4e.jpg";